module.exports = __webpack_public_path__ + "img/exit_human_fr-be.49b20279.svg";